<template>
    <div class="History">
        <div class="pageContent">
            <TopLogoBar logoColor="black" logoSpecial="93" textColor="#000" title="1993 IERI, OGGI E DOMANI" />
            <div class="container infoContainer">
                <div class="columns">
                    <div class="column is-6">
                        <p class="descriptionText">
                            La storia di page93® è quella di tre imprenditori del mondo
                            dell’informatica: <b>Graziella Bordone</b>, <b>Roberto Molino</b> e
                            <b>Giorgio Vacchetto</b>, ma è anche la storia di tutti noi, di
                            un’evoluzione durata venticinque anni, unica e irripetibile.
                            E’ una storia di passioni, di viaggi, di vino e di sport, e poi di
                            computer e di programmi che aiutano le aziende a crescere
                            e migliorarsi.<br><br>
                            <b>Questa storia comincia in un garage nel 1993.</b><br>
                            Bordone, Molino e Vacchetto si incontrano per la prima
                            volta in Orma, una società piemontese che, nei primi anni
                            ‘80, comincia a commercializzare computer Olivetti. Dopo
                            Orma, Computerlandia, e dopo ancora, nel 1993, nasce
                            Package Azienda. Dopo Olivetti, il garage e dopo il garage
                            due sedi, una ad Alba e una ad Asti con tre soci, quindici
                            collaboratori e quattrocento clienti.<br><br>
                            <b>Oggi Package Azienda è diventata page93®.</b><br>
                            Quelli che nel 1993 erano pacchetti informatici per tutti, oggi
                            per l’utente finale i programmi gestionali sono diventate
                            “semplici” pagine di dialogo
                        </p>
                    </div>
                    <div class="column is-6 imageContainer">
                        <img src="@/assets/images/garage_old.jpg" />
                    </div>
                </div>
            </div>
            <div class="container infoContainer">
                <div class="columns is-multiline">
                    <div class="column is-12" style="text-align: right">
                        <h2 class="parTitle">Da PAckaGE a page93®</h2>
                    </div>
                    
                    <div class="column is-6" style="text-align: center;">
                        <img src="@/assets/images/brand.jpg" />
                    </div>
                    <div class="column is-6">
                        <p class="descriptionText"  style="text-align: right; margin: 0">
                            Il mondo dell’informatica si è evoluto a una velocità elevatissima.
                            <br><br>

                            In occasione del suo 25° compleanno
                            <b>Package Azienda, nata nel 1993, diventa page93®</b>.

                            <br><br>
                            Quelli che nel 1993 erano pacchetti informatici per tutti oggi, per l’utente finale,
                            sono <i>semplici</i> pagine di dialogo per il controllo e lo sviluppo della
                            propria azienda.
                        </p>
                    </div>
                </div>
            </div>
            <div class="container infoContainer">
                <div class="columns is-multiline is-vcentered">
                    <div class="column is-4">
                        <h2 class="parTitle">Il marchio</h2>
                        <p class="descriptionText">
                            Il nuovo marchio racchiude in sè tutta la storia di <b>page93®</b> dalle origini sino a oggi.
                            <br><br>
                            <b>page93®</b> vive delle sue caratteristiche, della sua qualità e di quello che evoca.
                        </p>
                    </div>
                    <div class="column is-8">
                        <img src="@/assets/images/logoSpiegazione.jpg" />
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer'
    import TopLogoBar from '@/components/TopLogoBar'
    export default {
        name: 'History',
        props: [],
        components: {
            TopLogoBar,
            Footer
        },
    }
</script>

<style scoped lang="scss">
    .History {
        width: 100%;

        .pageContent {
            width: 100%;
            position: relative;
            color: #000;

            
            .parTitle {
                font-weight: 900;
                font-size: 26px;
            }


            .infoContainer {
                display: flex;
                // height: 100%;
                padding: 20px;
            }

            .descriptionText {
                font-size: 1.1rem;
                font-weight: 400;
                text-align: left;
                text-align: justify;

                @media only screen and (min-width: 768px) {
                margin-right: 30px;
                    margin-top: 60px;
                }
            }

            .imageContainer {
                @media only screen and (min-width: 768px) {
                    margin-top: 60px;
                }

                img {

                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

            }
        }
    }
</style>